export default {
  save_status: {
    SAVED: 1,
    SAVING: 2,
    UNSAVED: 3,
    ERROR_SAVING: 4
  },
  ticket_status: {
    OPEN: 2,
    PENDING: 3,
    RESOLVED: 4,
    CLOSED: 5,
    WAITING_CUSTOMER: 6,
    WAITING_FOR_SIGN_OFF: 11,
    WAITING_FOR_SCOPING: 14,
    IN_BACKLOG: 15,
    PENDING_DEPLOY: 16,
    PENDING_STAGING_DEPLOY: 17,
    ESCALATED: 18,
    SLA_HOURS_EXHAUSTED: 19,
  },
  ticket_status_colors: {
    2:  '#2da748',
    3:  '#f08c00',
    4:  '#495057',
    5:  '#495057',
    6:  '#ca8a04',
    11: '#0360dc',
    14: '#0360dc',
    15: '#6c757d',
    16: '#9747ff',
    17: '#9747ff',
    18: '#c62b3b',
    19: '#c62b3b',
  }
}
